<template>
    <div class="toolbar">
        <!-- <colorPicker></colorPicker> -->
    </div>
</template>

<script>
import colorPicker from './colorPicker'
export default {
  name: 'toolbar',
  components: {
    colorPicker: colorPicker
  }
}
</script>

<style scoped>
.toolbar{
  position: fixed;
  bottom: 0;
  margin: auto;
  text-align: center;
  width: 50%;
  margin: 0 25% 0 25%;
  padding: 0 0 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/board/toolbar/toolbar.vue